/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PresentationConfigDtoSectionsInner } from './PresentationConfigDtoSectionsInner';
import {
    PresentationConfigDtoSectionsInnerFromJSON,
    PresentationConfigDtoSectionsInnerFromJSONTyped,
    PresentationConfigDtoSectionsInnerToJSON,
    PresentationConfigDtoSectionsInnerToJSONTyped,
} from './PresentationConfigDtoSectionsInner';

/**
 * 
 * @export
 * @interface PresentationConfigDto
 */
export interface PresentationConfigDto {
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDto
     */
    themeId?: string | null;
    /**
     * 
     * @type {Array<PresentationConfigDtoSectionsInner>}
     * @memberof PresentationConfigDto
     */
    sections: Array<PresentationConfigDtoSectionsInner>;
}

/**
 * Check if a given object implements the PresentationConfigDto interface.
 */
export function instanceOfPresentationConfigDto(value: object): value is PresentationConfigDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sections' in value) || value['sections'] === undefined) return false;
    return true;
}

export function PresentationConfigDtoFromJSON(json: any): PresentationConfigDto {
    return PresentationConfigDtoFromJSONTyped(json, false);
}

export function PresentationConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentationConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'themeId': json['themeId'] == null ? undefined : json['themeId'],
        'sections': ((json['sections'] as Array<any>).map(PresentationConfigDtoSectionsInnerFromJSON)),
    };
}

export function PresentationConfigDtoToJSON(json: any): PresentationConfigDto {
    return PresentationConfigDtoToJSONTyped(json, false);
}

export function PresentationConfigDtoToJSONTyped(value?: PresentationConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'themeId': value['themeId'],
        'sections': ((value['sections'] as Array<any>).map(PresentationConfigDtoSectionsInnerToJSON)),
    };
}

